export const TEAM_STORIES = [
  {
    slug: "musa-hakim",
    name: "Musa Hakim",
    role: "Founder",
    company: "Maskanh",
    image: "/assets/Musa.jpeg",
    imagePosition: "42% 22%",
    linkLabel: "Our Mission",
    quote:
      "Maskanh started with a simple observation: finding a technician is easy but finding one you can trust is not.",
    headline:
      "Musa Hakim founded Maskanh to bring trusted home services to Kamra & Attock",
    subtitle:
      "Building a verified network of professionals so homeowners can hire with confidence.",
    overview:
      "Maskanh started with a simple observation: finding a technician is easy but finding one you can trust is not. We're building a network of verified professionals in Kamra and Attock so homeowners can hire with confidence. Every technician is vetted, tracked and held accountable through our verification process. Our goal is simple: remove the uncertainty from home services.",
    challenge:
      "Homeowners in Kamra and Attock could find technicians easily, but had no reliable way to know who was skilled, accountable, or fairly priced. That uncertainty made people hesitant to book — especially for urgent AC and home service needs.",
    solution: [
      {
        title: "Verified Technician Network",
        text: "Maskanh built a network of background-checked AC technicians, electricians, and plumbers — each verified before joining the platform.",
      },
      {
        title: "WhatsApp-First Booking",
        text: "Customers fill a simple form on maskanh.com and receive WhatsApp confirmation within 30 minutes — no app download required.",
      },
      {
        title: "Google Sheets Lead Pipeline",
        text: "Every service request flows directly into a structured backend, ensuring no lead is missed and dispatch is fast.",
      },
    ],
    impact: [
      "30-minute WhatsApp confirmation for every booking",
      "Verified technicians only — no random contractors",
      "Serving Kamra, Attock, and expanding across Punjab",
    ],
    useCase: "Platform Leadership",
    products: ["AC Services", "Lead Management", "Technician Verification"],
  },
  {
    slug: "muhammad-ubaid-obaid",
    name: "Muhammad Obaid",
    role: "Technical Head",
    company: "Maskanh",
    image: "/assets/Obaid.jpg",
    interactive3D: true,
    linkLabel: "Read Our Story",
    quote:
      "Great service starts with skilled technicians and smart systems. I lead our field teams on the ground while building the software that keeps every booking fast and reliable.",
    headline:
      "Muhammad Obaid leads technician operations and builds Maskanh's digital platform",
    subtitle:
      "Combining hands-on technical leadership with software engineering to power Maskanh's service delivery across Kamra and Attock.",
    overview:
      "Muhammad Obaid serves as Technician Head and Software Engineering lead at Maskanh. On the field side, he oversees technician standards, training coordination, and quality checks. On the tech side, he builds and maintains maskanh.com, lead pipelines, and the tools that connect customers with verified service providers.",
    challenge:
      "Running a home-services platform requires two things at once: technicians who deliver consistent on-site quality, and digital systems that don't lose leads or slow down dispatch. Without both, customers wait too long and jobs fall through the cracks.",
    solution: [
      {
        title: "Technical Leadership",
        text: "Muhammad coordinates Maskanh's technician network — ensuring the right skills are matched to each job and service standards are met on every visit.",
      },
      {
        title: "Platform Development",
        text: "He engineers maskanh.com, form integrations, and backend workflows so every service request is captured, routed, and confirmed without manual gaps.",
      },
      {
        title: "Quality & Feedback Loop",
        text: "Field insights from technicians feed back into product improvements — faster booking, clearer communication, and better customer outcomes.",
      },
    ],
    impact: [
      "Unified technician standards across Kamra & Attock",
      "Reliable digital booking and lead management",
      "Faster dispatch through software-driven workflows",
    ],
    useCase: "Technical Leadership & Engineering",
    products: ["Technician Operations", "Web Platform", "Lead Automation"],
  },
  {
    slug: "bader-islam",
    name: "Bader Islam",
    role: "Business Operator",
    company: "Maskanh",
    image: "/assets/Bader.jpg",
    linkLabel: "Read Our Story",
    quote:
      "Smooth operations are what turn a good service into a great experience. I make sure every booking, dispatch, and follow-up runs efficiently behind the scenes.",
    headline:
      "Bader Islam keeps Maskanh's business operations running smoothly across Kamra & Attock",
    subtitle:
      "Managing day-to-day operations, vendor coordination, and service delivery workflows for the Maskanh platform.",
    overview:
      "Bader Islam leads business operations at Maskanh — coordinating technician schedules, tracking service requests, and ensuring customers receive timely confirmations and follow-ups from booking to job completion.",
    challenge:
      "Growing demand for AC and home services in Kamra and Attock created bottlenecks — missed calls, delayed dispatch, and inconsistent follow-up were hurting customer trust and repeat business.",
    solution: [
      {
        title: "Streamlined Dispatch Workflow",
        text: "Bader built clear processes so every form submission is assigned, confirmed, and tracked until the job is complete.",
      },
      {
        title: "Vendor & Technician Coordination",
        text: "He manages relationships with service providers and technicians to keep availability accurate and response times low.",
      },
      {
        title: "Operational Reporting",
        text: "Daily tracking of leads, completions, and customer feedback helps the team spot issues early and improve service quality.",
      },
    ],
    impact: [
      "Faster booking-to-dispatch turnaround",
      "Consistent WhatsApp confirmations for customers",
      "Reliable operations across Kamra & Attock",
    ],
    useCase: "Business Operations",
    products: ["Dispatch", "Vendor Management", "Service Tracking"],
  },
  {
    slug: "waleed-ahmed",
    name: "Waleed Ahmed",
    role: "Graphic Designer",
    company: "Maskanh",
    image: "/assets/Waleed.jpg",
    linkLabel: "Read Our Story",
    quote:
      "Strong visuals help customers trust a brand before they ever book a service. I design Maskanh's look so it feels professional, local, and easy to understand.",
    headline:
      "Waheel Ahmed shapes Maskanh's visual identity and brand design",
    subtitle:
      "Creating graphics, social media assets, and marketing visuals that represent Maskanh across digital channels.",
    overview:
      "Waheel Ahmed is Maskanh's Graphic Designer — responsible for brand visuals, social media graphics, service banners, and marketing materials that help customers recognize and trust the platform.",
    challenge:
      "Home service businesses often look unprofessional online — inconsistent logos, low-quality posts, and unclear visuals make customers hesitant to book, especially for first-time users.",
    solution: [
      {
        title: "Brand Visual System",
        text: "Waheel maintains consistent colors, typography, and layout across Maskanh's website, social posts, and promotional assets.",
      },
      {
        title: "Social & Marketing Graphics",
        text: "He designs service highlights, seasonal campaigns, and WhatsApp-ready visuals that communicate offers clearly.",
      },
      {
        title: "Service & Team Imagery",
        text: "From icons to team presentation graphics, he ensures every touchpoint looks polished and on-brand.",
      },
    ],
    impact: [
      "Consistent Maskanh brand identity online",
      "Professional visuals for social media and ads",
      "Clearer service communication through design",
    ],
    useCase: "Brand & Design",
    products: ["Brand Design", "Social Graphics", "Marketing Assets"],
  },
  {
    slug: "maiza-fatima",
    name: "Maiza Fatima",
    role: "Content Writer",
    company: "Maskanh",
    image: "/assets/Maiza.jpg",
    linkLabel: "Read Our Story",
    quote:
      "Clear words build trust. I write content that explains our services simply so customers in Kamra and Attock know exactly what they're booking.",
    headline:
      "Maiza Fatima writes clear, customer-focused content for Maskanh",
    subtitle:
      "Crafting website copy, service descriptions, and blog content that helps customers understand and choose Maskanh services.",
    overview:
      "Maiza Fatima is Maskanh's Content Writer — creating website copy, service descriptions, blog posts, and customer-facing messages that explain AC and home services in plain, trustworthy language.",
    challenge:
      "Technical service terms can confuse homeowners. Without clear content, customers hesitate to book because they don't understand what's included, how pricing works, or why Maskanh is different.",
    solution: [
      {
        title: "Website & Service Copy",
        text: "Maiza writes homepage, service page, and form content that answers common customer questions before they ask.",
      },
      {
        title: "Blog & SEO Content",
        text: "She creates helpful articles on AC maintenance, seasonal tips, and local service guides to attract and educate customers.",
      },
      {
        title: "Customer Communication Scripts",
        text: "Clear WhatsApp and follow-up message templates help the team respond consistently and professionally.",
      },
    ],
    impact: [
      "Easier-to-understand service offerings",
      "Stronger customer trust through clear messaging",
      "Better engagement from local search and blog content",
    ],
    useCase: "Content & Messaging",
    products: ["Website Copy", "Blogs", "Customer Messaging"],
  },
];

const SLUG_ALIASES = {
  "musa-ahmad": "musa-hakim",
  "bader-khan": "bader-islam",
  "waleed-hassan": "waheel-ahmed",
  "aliza-fatima": "maiza-fatima",
};

export function getStoryBySlug(slug) {
  const resolved = SLUG_ALIASES[slug] || slug;
  return TEAM_STORIES.find((story) => story.slug === resolved);
}
